import { motion } from "framer-motion";

const T = [
  {
    quote:
      "We are extremely satisfied with the quality of work delivered by the Muse n Aura team. The project was completed within the committed timeline with exceptional professionalism, attention to detail, and minimal disruption to our hotel operations.",
    who: "General Manager",
    role: "Wonderla Resort, Bangalore",
  },
  {
    quote:
      "I had the pleasure of working with my dream team Muse & Aura Designs for the interior design project of my house, and I couldn't be more impressed! The team was extremely helpful, receptive, and proactive throughout the entire process.",
    who: "Aditya Ranade",
    role: "Private Residence",
  },
  {
    quote:
      "Right from the designs to selections to executions, it was a breeze to work with Muse n Aura Designs team. Best part about working with them is that they own up the project and takes full responsibility of it.",
    who: "Shreya Tandon",
    role: "Private Residence",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-bone" data-testid="testimonials-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="flex items-end justify-between mb-16 md:mb-24 gap-6 flex-wrap">
          <p className="text-[11px] uppercase tracking-[0.3em] text-muteInk">— Kind words</p>
          <a
            href="https://www.google.com/search?q=Muse+n+Aura+Designs+reviews"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-link"
            className="inline-flex items-center gap-3 text-[11px] uppercase tracking-[0.22em] text-ink editorial-link group"
          >
            <svg viewBox="0 0 24 24" className="w-4 h-4" aria-hidden="true">
              <path fill="#4285F4" d="M22.5 12.27c0-.79-.07-1.54-.2-2.27H12v4.51h5.92a5.06 5.06 0 0 1-2.19 3.32v2.75h3.54c2.07-1.9 3.23-4.7 3.23-8.31z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.27-2.66l-3.54-2.75c-.98.66-2.23 1.05-3.73 1.05-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.11A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.11V7.05H2.18A11 11 0 0 0 1 12c0 1.77.42 3.45 1.18 4.95l3.66-2.84z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.05l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38z"/>
            </svg>
            <span>Read our Google reviews</span>
            <span className="text-clay group-hover:translate-x-1 transition-transform duration-300">→</span>
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-14">
          {T.map((t, i) => (
            <motion.figure
              key={t.who}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="border-t border-borderWarm pt-8"
            >
              <span className="chapter-num text-5xl leading-none">“</span>
              <blockquote className="font-serif text-lg md:text-xl leading-[1.35] text-ink mt-4 tracking-tight">
                {t.quote}
              </blockquote>
              <figcaption className="mt-8 text-[11px] uppercase tracking-[0.28em] text-muteInk">
                {t.who} · <span className="text-ink">{t.role}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
